"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Multiplexer = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const toolbox_1 = require("@streem/toolbox");
const streem_error_1 = require("../streem_error");
const compositor_1 = require("./compositor");
const streemshot_engine_1 = require("./engines/rendering/streemshot_engine");
const tool_engine_1 = require("./engines/rendering/tool_engine");
const managers_1 = require("./managers");
const stats_1 = require("./util/stats");
const __1 = require("..");
const filter_null_1 = require("../util/rx/filter_null");
class Multiplexer {
    constructor(config) {
        const context = {
            container: config.container,
            roomSession: config.roomSession,
        };
        this.renderingManager = new managers_1.RenderingManager(Object.assign(Object.assign({}, context), { compositor: this.buildCompositor({
                videoStarter: config.videoStarter,
                laserMessages: config.roomSession.tools.laserMessages,
                drawMessages: config.roomSession.tools.drawMessages,
                dataTrack: config.roomSession.media.data.messages,
                cameraSubject: config.cameraSubject,
            }), streemshotEngine: new streemshot_engine_1.StreemshotEngine() }));
        this.canvasDimensions = this.renderingManager.bufferProperties.pipe((0, filter_null_1.filterNull)());
        this.canvasDimensions.subscribe();
        if ((0, __1.isSpectatorRoomSession)(config.roomSession) || (0, __1.isOnSiteRoomSession)(config.roomSession)) {
            this.interactionManager = new managers_1.InteractionManager(context);
        }
        this.cameraSubject = config.cameraSubject;
        this.isLocalVideo = config.isLocalVideo;
        this.roomSession = config.roomSession;
    }
    start() {
        (0, toolbox_1.invariant)(!this.unsubscriber, 'Cannot start Multiplexer if already running');
        // If the customer refreshes the call and streemshots were previously taken, we need to have access to
        // streemshot responses before requests so we don't try to fulfill requests again
        const subscribeToStreemshotResponses = this.roomSession.streemshots.responses.subscribe(() => { });
        const unsubscribeVideo = this.renderingManager.renderVideoForUser();
        const unsubscribeStreemshotRequestsForWeb = this.supportsStreemshotFulfillment()
            ? this.renderingManager.fulfillStreemshotRequestsForWeb()
            : () => { };
        const unsubscribeInteractions = this.interactionManager
            ? this.interactionManager.startListening(this.renderingManager.cameraFrame)
            : () => { };
        this.unsubscriber = () => {
            unsubscribeVideo();
            unsubscribeInteractions();
            unsubscribeStreemshotRequestsForWeb();
            subscribeToStreemshotResponses.unsubscribe();
        };
    }
    supportsStreemshotFulfillment() {
        const ALLOWED_CAMERA_SUBJECTS = new Set([
            streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD,
            streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN,
        ]);
        return this.isLocalVideo && ALLOWED_CAMERA_SUBJECTS.has(this.cameraSubject);
    }
    stop() {
        (0, toolbox_1.invariant)(this.unsubscriber, 'Cannot stop Multiplexer if not running');
        this.unsubscriber();
    }
    buildCompositor(config) {
        const compositorConfig = {
            videoStarter: config.videoStarter,
            stats: new stats_1.StatsPanel(),
        };
        // TODO https://streempro.atlassian.net/browse/STREEM-8225
        // Camera switching will involve handling using different compositors
        // We should create something similar to Go's Context package to
        // signal the compositor to pause while we create a new compositor.
        switch (config.cameraSubject) {
            case streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD:
                return new compositor_1.EnvironmentCompositor(Object.assign(Object.assign({}, compositorConfig), { toolEngine: new tool_engine_1.ToolEngine(config.laserMessages, config.drawMessages) }));
            case streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON:
                return new compositor_1.UserCompositor(compositorConfig);
            case streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN:
                return new compositor_1.ScreenCompositor(Object.assign(Object.assign({}, compositorConfig), { toolEngine: new tool_engine_1.ToolEngine(config.laserMessages, config.drawMessages) }));
            default:
                throw new streem_error_1.StreemError('a valid compositor must be defined');
        }
    }
}
exports.Multiplexer = Multiplexer;
//# sourceMappingURL=multiplexer.js.map